const api = "https://api.funtabs.cn";
// const api = "https://localhost:8081"; //测试地址

const variable = {
	login: api + "/api/login",
	register: api + "/api/register",
	saveData: api + "/api/saveData",
	getData: api + "/api/getData",
	getUserInfo: api + "/api/getUserInfo",
	uploadImages: api + "/api/uploadWallpaper",
	uploadFavicon: api + "/api/uploadFavicon",
	changeUserInfo: api + "/api/changeUserInfo",
	changePassword: api + "/api/changePassword",
	deleteUserAccount: api + "/api/deleteUserAccount",
	getMoreProducts: api + "/api/getMoreProducts",
	webTitle: api + "/webTitle?url=",
	getArticleContent: api + "/article?url=",
	image: api + "/image?url=",
	favicon: api + "/favicon?url=",
	hotEvent: api + "/hotEvent",
	fanyi: api + "/fanyi",
	funtabsData: api + "/api/getFuntabsDefaultData",
	getMessage: api + "/api/funtabs/message",
	saveWebInfo: api + "/api/saveWebInfo",
	uploadAvatar: api + "/api/uploadAvatar",
	weather: api + "/weather",
	festival: api + "/calendar/festival",
	cityList: api + "/weather/cityList",
	getAccountBind: api + "/api/accountBind/getUserBind",
	getEmailCode: api + "/api/accountBind/getCode",
	bindEmail: api + "/api/accountBind/bindEmail",
	findPassword: api + "/api/findPassword",
	personalDomainSet: api + "/api/personalDomainSet",
	getPersonalDomainSet: api + "/api/personalDomainSet/get",
	deleteDomain: api + "/api/personalDomainSet/delete",
	getPersonalData: api + "/api/getPersonalDomainData",
	randomWallpaper: api + "/wallpaper/random",
};
export default variable;
